import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      // color: PrimaryTheme.primary
    },
  }),
);

export default function Header(props: HeaderProps) {
  const classes = useStyles();

  return (
    <div className={classes.root + ` ${props.classNames}`}>
      <AppBar position="sticky" className="bg-color">
        <Toolbar variant="regular">
          <div className="row m-0 justify-content-center align-align-items-center">
            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
              {/* <MenuIcon/> */}
            </IconButton>

            <a className="navbar-brand" href="/" style={{
              paddingTop: 15
            }}>
              {/* <img src="/logo.png" width="100" className="d-inline-block align-top" alt="" loading="lazy" /> */}
            </a>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

interface HeaderProps {
  classNames: string;
}
